<template>
  <v-app-bar color="red">
    <v-toolbar-title>{{ title }}</v-toolbar-title>
  </v-app-bar>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const title = ref('Montel')
</script>
